import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';

import { RqaSidebarComponent } from './app.sidebar';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './app.loader';

@Component({
  selector: 'rqa-layout',
  standalone: true,
  imports: [CommonModule, RqaSidebarComponent, RouterModule, LoaderComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<div class="layout-wrapper">
    <div class="layout-sidebar-container">
      <rqa-sidebar></rqa-sidebar>
    </div>
    <div class="layout-main-area">
      <div class="layout-main-content">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="layout-mask animate-fadein"></div>
    <rqa-loader></rqa-loader>
  </div> `
})
export class RqaLayoutComponent {}
